<template>
    <div :class="getStatusHeader ? 'barLine' : 'barLine-minimaze'">
        <div class="barLine-title">
            {{title}}
        </div>
        <div :class="getStatusHeader ? 'barLine-wrap' : 'barLine-wrap-minimaze'">
            <div :class="getStatusHeader ? 'barLine-data' : 'barLine-data-minimaze'"
                    :style = "{color: getMaxddStyle.color}">
                {{getVariant}}%
            </div>
            <div
                :class="getStatusHeader ? 'barLine-bar' : 'barLine-bar-minimaze'"
                :style = "{'flex-direction': getMaxddStyle.reverse}">
                <div class="barLine-greenLine"
                    :style="{ width: (variant === 'maxdd') ? (100 - getVariant) : getVariant + '%'}">
                    <div
                        :class="getStatusHeader ? 'barLine-greenSubline' : 'barLine-greenSubline-minimaze'"></div>
                </div>
                <div
                    class="barLine-redLine"
                    :style="{ width: (variant === 'maxdd') ? getVariant : (100 - getVariant) + '%'}">
                    <div :class="getStatusHeader ? 'barLine-redSubline' : 'barLine-redSubline-minimaze'"></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
    data(){
        return {
            statistic:{},
            widthBar:0
        }
    },
    props: {
        variant:{default:'profitDeals'},
        title:{default:'% УСПЕШНЫХ СДЕЛОК'}
    },
    computed: {
    ...mapGetters({
              getStatistics: 'accountstat/getStatistics',
              getOpenPositions: '',
              getStatusHeader:'usersets/getHeader'
        }),
        getVariant () {
            let variant = {
                profitDeals:98,
                maxdd:37.49,
                openPositions:this.openPsitionsPercent()
            }

            return variant[this.variant]
        },
        getMaxddStyle() {
            let color = {}
            if (this.variant === 'maxdd')
                return color = {
                    color:'#ff9292',
                    reverse: 'row-reverse'
                };
            else {
                 return color = {
                    color:'#00ffd0',
                    reverse: 'row'
                };
            }
        }
    },
    methods: {
      updateStatistics(symbol,param)
      {
          if (!symbol) symbol = this.symbol;
            let stat = this.getStatistics(symbol);
            if (!stat) {
                return;
            }
            this.statistic = stat;
            let profitDeals = (stat.Summary.ProfitableDeals / (stat.Summary.TotalDeals / 100)).toFixed()
            return profitDeals;
      },
      openPsitionsPercent() {
        let filterOpenPositions = [
            { field: "symbol", dir: "asc" },
            { field: "timeEnter", dir: "asc" }
            ];
        let flatStat = this.$store.getters["positions/positionsFlatFiltered"](filterOpenPositions);
        let countDeals = flatStat.length
            let sumProfitDeals = 0;
            for (let i = 0; i < flatStat.length; i++)
                if(flatStat[i].resultDepo > 0)
                    sumProfitDeals += 1;
            let percentProfitdeals = Math.ceil(sumProfitDeals / (countDeals / 100));
            return percentProfitdeals;
      }
  },
  created() {
        subscribeOnUpdate(this.$store, '', isFirstObtained => {
            if (!this.symbol || !this.symbol.length) {
                this.updateStatistics()
            }
            this.updateStatistics()
        });
    }
};

function subscribeOnUpdate(store, symbol, handler) {
    store.dispatch("accountstat/subscribeOnUpdate", {
        symbol: "",
        callback: {
            id: "header-barline",
            handler: handler
        }
    });
};
</script>
<style lang="less" scoped>
@keyframes change-padding {
    from {
        padding: 8px 12px 12px 12px;
    }
    to {
        padding: 4px 12px 12px 12px;
    }
}
@keyframes change-padding-full {
    from {
        padding: 4px 12px 12px 12px;
    }
    to {
        padding: 8px 12px 12px 12px;
    }
}
@keyframes change-font {
    from {
        font-size: 16px;
    }
    to {
        padding: 14px;
    }
}
@keyframes change-line {
    from {
        line-height: 1.25;
    }
    to {
        line-height: 1;
    }
}
@keyframes change-margin {
    from {
        margin-top: 8px;
    }
    to {
        margin-top: 0px;
    }
}
.barLine {
    animation: change-padding-full 0.6s ease-in 1;
  display: flex;
  flex-direction: column;
  background: #3d536b;
  margin-right: 1px;
  padding: 8px 12px 12px 12px;
  flex-grow: 1;
  height: 88px;
  min-width: 170px;
  box-sizing: border-box;
  @media screen and (min-width: 2240px) {
      min-width: 200px;
  }
  @media screen and (min-width: 2483px) {
      min-width: 180px;
  }
  &-wrap {
      &-minimaze {
          display:flex;
      }
  }
  &-minimaze {
        animation: change-padding 0.6s ease-in 1;
        display: flex;
        flex-direction: column;
        background: #3d536b;
        margin-right: 1px;
        padding: 4px 12px 12px 12px;
        flex-grow: 1;
        height: 88px;
        min-width: 170px;
        box-sizing: border-box;
    @media screen and (min-width: 2240px) {
        min-width: 200px;
    }
    @media screen and (min-width: 2483px) {
        min-width: 180px;
    }
  }
  &-title {
    font-family: Arimo;
    font-size: 10px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.6;
    letter-spacing: 0.4px;
    color: #ffffff;
    text-transform: uppercase;
  }
  &-data {
    font-family: Arimo;
    font-size: 16px;
    //font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.25;
    letter-spacing: 0.4px;
    margin-top: 8px;
    color: @colors[green];
    &-minimaze {
        animation: change-font 0.6s ease-in 1;
        animation: change-line 0.6s ease-in 1;
        animation: change-margin 0.6s ease-in 1;
        font-family: Arimo;
        font-size: 14px;
        font-style: normal;
        font-stretch: normal;
        line-height: 1;
        letter-spacing: 0.4px;
        margin-top: 0px;
        margin-right: 4px;
        color: @colors[green];
    }
  }
  &-bar {
    width: 100%;
    display: flex;
    height: 20px;
    &-revers {
        width: 100%;
        display: flex;
        height: 20px;
        flex-direction: row-reverse;
    }
    &-minimaze {
        width: 100%;
        display: flex;
        height: 15px;
    }
  }
  &-greenLine {
    background-color: rgba(0, 255, 208,0.2);
    display: flex;
    align-items: center;
    width: 80%;
  }
  &-greenSubline {
    width: 100%;
    height: 2px;
    display: block;
    border-bottom: solid 2px @colors[green];
    &-minimaze {
        width: 100%;
        display: block;
        border-bottom: solid 2px @colors[green];
    }
  }
  &-redLine {
    width: 20%;
    display: flex;
    align-items: center;
    background-color: rgba(255, 146, 146,0.1);
  }
  &-redSubline {
    width: 100%;
    height: 2px;
    display: block;
    border-bottom: solid 2px @colors[red];
    &-minimaze {
        width: 100%;
        display: block;
        border-bottom: solid 2px @colors[red];
    }
  }
}
</style>

